export type Environment = 'local' | 'dev' | 'qa' | 'prod';

export interface EnvironmentConfig {
  environment: Environment;
  bffUrl: string;
  healthCheckUrl: string;
  devxHomeUrl: string;
}

const ENVIRONMENT_CONFIGS: Record<Environment, Omit<EnvironmentConfig, 'environment'>> = {
  local: {
    bffUrl: 'https://apim-na-ai.dev.mypepsico.com/cgf/devx-gpt-bff-service/v1/assistant',
    healthCheckUrl: 'https://apim-na-ai.dev.mypepsico.com/cgf/devx-gpt-bff-service/v1/health/check',
    devxHomeUrl: 'https://devx.dev.mypepsico.com',
  },
  dev: {
    bffUrl: 'https://apim-na-ai.dev.mypepsico.com/cgf/devx-gpt-bff-service/v1/assistant',
    healthCheckUrl: 'https://apim-na-ai.dev.mypepsico.com/cgf/devx-gpt-bff-service/v1/health/check',
    devxHomeUrl: 'https://devx.dev.mypepsico.com',
  },
  qa: {
    bffUrl: 'https://apim-na-ai.dev.mypepsico.com/cgf/devx-gpt-bff-service/v1/assistant',
    healthCheckUrl: 'https://apim-na-ai.dev.mypepsico.com/cgf/devx-gpt-bff-service/v1/health/check',
    devxHomeUrl: 'https://devx.qa.mypepsico.com',
  },
  prod: {
    bffUrl: 'https://apim-na-ai.mypepsico.com/cgf/devx-gpt-bff-service/v1/assistant',
    healthCheckUrl: 'https://apim-na-ai.mypepsico.com/cgf/devx-gpt-bff-service/v1/health/check',
    devxHomeUrl: 'https://devx.mypepsico.com',
  },
};

const HOSTNAME_PATTERNS: Record<Environment, RegExp[]> = {
  local: [/^localhost$/, /^127\.0\.0\.1$/, /^0\.0\.0\.0$/],
  dev: [/\.dev\.mypepsico\.com$/, /\.eus\.nonprod\.azure\.intra\.pepsico\.com$/],
  qa: [/\.qa\.mypepsico\.com$/, /\.qa\.nonprod\.azure\.intra\.pepsico\.com$/],
  prod: [/\.mypepsico\.com$/, /\.prod\.azure\.intra\.pepsico\.com$/],
};

export function detectEnvironment(hostname: string = window.location.hostname): Environment {
  for (const [env, patterns] of Object.entries(HOSTNAME_PATTERNS)) {
    if (patterns.some((pattern) => pattern.test(hostname))) {
      return env as Environment;
    }
  }

  console.warn(`[DevXGPT] Unknown hostname: ${hostname}. Defaulting to prod.`);
  return 'prod';
}

export function getEnvironmentConfig(overrides?: Partial<EnvironmentConfig>): EnvironmentConfig {
  const environment = overrides?.environment || detectEnvironment();
  const config = ENVIRONMENT_CONFIGS[environment];

  const finalConfig: EnvironmentConfig = {
    environment,
    bffUrl: overrides?.bffUrl || config.bffUrl,
    healthCheckUrl: overrides?.healthCheckUrl || config.healthCheckUrl,
    devxHomeUrl: overrides?.devxHomeUrl || config.devxHomeUrl,
  };

  if (environment !== 'prod') {
    console.group('[DevXGPT] Environment Configuration');
    console.log('Environment:', finalConfig.environment);
    console.log('Hostname:', window.location.hostname);
    console.log('BFF URL:', finalConfig.bffUrl);
    console.log('Health Check URL:', finalConfig.healthCheckUrl);
    console.log('DevXGPT Full Experience URL:', finalConfig.devxHomeUrl);
    console.groupEnd();
  }

  return finalConfig;
}

export function isDevelopment(): boolean {
  return detectEnvironment() !== 'prod';
}
